export const SpaceCapacityModel = Symbol.for('SpaceCapacityModel');
